module.exports = __webpack_public_path__ + "static/img/TheApartmentLoungeImage.a7b2a74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/places/TheApartmentLoungeImage.png
// module id = g5WE
// module chunks = 0